export enum FreeCancellationFilter {
  All = 'default',
  FreeCancellation = 'true',
  NonRefundable = 'false',
}
